"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_router_1 = require("react-router");
var formik_1 = require("formik");
var antd_1 = require("antd");
var contexts_1 = require("../../contexts");
var PromptIfDirty = function () {
    var formProps = react_1.useContext(contexts_1.FormContext).formProps;
    if (formProps) {
        return react_1.default.createElement(react_router_1.Prompt, { when: formProps.dirty && formProps.submitCount === 0, message: "ui.message.form.dirty" });
    }
    return react_1.default.createElement(react_1.default.Fragment, null);
};
var Form = function (props) {
    var initialValues = props.initialValues, validationSchema = props.validationSchema, onSubmit = props.onSubmit, actions = props.actions, promptOnDirty = props.promptOnDirty, children = props.children;
    var emptyAction = function () { return undefined; };
    var handleSubmit = onSubmit || emptyAction;
    var values = (initialValues || {});
    return (react_1.default.createElement(formik_1.Formik, { enableReinitialize: true, initialValues: values, validationSchema: validationSchema, onSubmit: handleSubmit, validateOnChange: false, validateOnBlur: false, render: function (formikProps) {
            return (react_1.default.createElement(antd_1.Form, null,
                react_1.default.createElement(contexts_1.FormContext.Provider, { value: { formProps: formikProps } },
                    promptOnDirty && react_1.default.createElement(PromptIfDirty, null),
                    children,
                    react_1.default.createElement("div", { className: "ant-app-form-actions" }, react_1.default.Children.toArray(actions)))));
        } }));
};
exports.default = Form;
